import type { KPICardData } from "@/components/v2/kpi-row";
import type { DemoCatalogEntry } from "@adva/types";

const KPI_PRIORITY = [
  "contacts",
  "customers",
  "opportunities",
  "jobs",
  "invoices",
  "proposals",
];

export function buildDemoCatalogKpis(entry: DemoCatalogEntry): KPICardData[] {
  const tiles: KPICardData[] = [
    {
      label: "Total records",
      value: entry.total_records.toLocaleString(),
    },
  ];

  for (const key of KPI_PRIORITY) {
    const count = entry.record_counts[key];
    if (count !== undefined) {
      tiles.push({
        label: key.charAt(0).toUpperCase() + key.slice(1),
        value: count.toLocaleString(),
      });
    }
  }

  return tiles;
}
